module.exports = __webpack_public_path__ + "static/10-e161f227312b9badb02cb0b20fa2cf21.jpg";